"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearLocalOverride = exports.setLocalOverride = exports.getLocalOverride = void 0;

var window_1 = require("./window");

var OVERRIDE_PREFIX = 'dashboard-constants-override';

var getLocalOverride = function getLocalOverride(key) {
  if (key === undefined) {
    return undefined;
  }

  var storageKey = "".concat(OVERRIDE_PREFIX, "_").concat(key);
  return (window_1.polymorphicWindow === null || window_1.polymorphicWindow === void 0 ? void 0 : window_1.polymorphicWindow.localStorage.getItem(storageKey.toLowerCase())) || undefined;
};

exports.getLocalOverride = getLocalOverride;

var setLocalOverride = function setLocalOverride(key, value) {
  var storageKey = "".concat(OVERRIDE_PREFIX, "_").concat(key);
  window_1.polymorphicWindow === null || window_1.polymorphicWindow === void 0 ? void 0 : window_1.polymorphicWindow.localStorage.setItem(storageKey.toLowerCase(), value);
};

exports.setLocalOverride = setLocalOverride;

var clearLocalOverride = function clearLocalOverride(key) {
  var storageKey = "".concat(OVERRIDE_PREFIX, "_").concat(key);
  window_1.polymorphicWindow === null || window_1.polymorphicWindow === void 0 ? void 0 : window_1.polymorphicWindow.localStorage.removeItem(storageKey.toLowerCase());
};

exports.clearLocalOverride = clearLocalOverride;